export const TommyErAddressColumns = [
    "BuySheetCtry",
    'BuySheetChnl', 
    'ShipToAddressCode',
    'ShipToAddress', 
    'ShipMode',
    'DeliveryAddressCode',
    'DeliveryAddress',
    'CoDeliveryAddressCode',
    'CoDeliveryAddress'

  
]